export default __webpack_public_path__ + "static/media/arrowDown.3e441711.svg";